import { cn } from "@/lib/utils"
import { Avatar, AvatarImage } from "@/components/ui/avatar"

export interface TestimonialAuthor {
  name: string
  handle: string
  avatar: string
}

export interface TestimonialCardProps {
  author: TestimonialAuthor
  text: string
  href?: string
  className?: string
}

export function TestimonialCard({ 
  author,
  text,
  href,
  className
}: TestimonialCardProps) {
  const Card = href ? 'a' : 'div'
  
  return (
    <Card
      {...(href ? { href } : {})}
      className={cn(
        "flex flex-col rounded-lg border border-slate-800",
        "bg-gradient-to-b from-slate-900/80 to-slate-800/40",
        "p-3 sm:p-6 text-start",
        "hover:from-slate-800/90 hover:to-slate-700/50",
        "hover:border-[#00B6F0]/40",
        "w-[280px] sm:w-[320px]",
        "transition-all duration-300",
        "backdrop-blur-sm",
        "shadow-lg hover:shadow-xl hover:shadow-[#00B6F0]/10",
        "flex-shrink-0",
        className
      )}
    >
      <div className="flex items-center gap-3">
        <Avatar className="h-10 w-10 sm:h-12 sm:w-12 ring-2 ring-[#00B6F0]/20">
          <AvatarImage src={author.avatar} alt={author.name} />
        </Avatar>
        <div className="flex flex-col items-start min-w-0">
          <h3 className="text-sm sm:text-md font-semibold leading-none text-white truncate w-full">
            {author.name}
          </h3>
          <p className="text-xs sm:text-sm text-[#00B6F0] truncate w-full">
            {author.handle}
          </p>
        </div>
      </div>
      <p className="mt-3 sm:mt-4 text-xs sm:text-sm text-slate-300 leading-relaxed line-clamp-4">
        {text}
      </p>
    </Card>
  )
} 